import React ,{useState, useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import dbar from '../data2/dbar';
import dbhe from '../data2/dbhe';
import dben from '../data2/dben';

export const useShuffle = () => {
  const location = useLocation();
  const [questions,setQuestions]=useState([])
  
    useEffect(()=>{
      if(location.pathname.includes("AR")){

        function shuffle(array) {
          array.sort(() => Math.random() - 0.5);
          return array
        }
        setQuestions(shuffle(dbar))
      }
      else if(location.pathname.includes("EN")){
        function shuffle(array) {
          array.sort(() => Math.random() - 0.5);
          return array
        }
        setQuestions(shuffle(dben))
      }
      else if(location.pathname.includes("HE")){
        function shuffle(array) {
          array.sort(() => Math.random() - 0.5);
          return array
        }
        setQuestions(shuffle(dbhe))
      }

        
      },[dbar,dben,dbhe])
      return {questions}
  
}